// @flow
import { transparentize } from 'polished';
import DOMResize from '~/components/dom/dom-resize';
import styled from 'styled-components';
import { TRANSITION_DEF } from './constants';

const svgComponentHeight = 32;
const resetScheduleHeight = 3;

export const Base = styled.div`
    height: ${svgComponentHeight + resetScheduleHeight}em;
    min-height: ${svgComponentHeight + resetScheduleHeight}em;
    min-width: 22.8571428em; /* which for a font size of 14px is 320px (the width of iPhone 4 screen) */
    position: relative;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;

export const Resize = styled(DOMResize)`
    height: ${svgComponentHeight}em;
    width: 100%;
`;

export const Container = styled.div`
    max-width: 100%;
    position: relative;
`;

export const ResetSchedule = styled.div`
    cursor: pointer;
    float: right;
    height: ${resetScheduleHeight}em;
    font-size: 1rem;
    line-height: ${resetScheduleHeight}em;
    padding: 0 2.2em;
    text-decoration: underline;
`;

export const Overlay = styled.div`
    align-items: center;
    background-color: ${p => transparentize(0.5, p.theme.secondaryColor)};
    color: ${p => p.theme.white};
    display: flex;
    height: 100%;
    justify-content: center;
    opacity: ${p => (p.show ? 1 : 0)};
    position: absolute;
    top: 0;
    transition: ${TRANSITION_DEF};
    pointer-events: ${p => (p.show ? 'auto' : 'none')};
    width: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/style.js